module.exports = __webpack_public_path__ + "img/06-oval-not-convex-1-2-base.579f2d7d.svg";